const colorCodes = {
  مشکی: "#111827",
  سفید: "#ffffff",
  کرم: "#eadcc8",
  عسلی: "#c58b45",
  سبز: "#16a34a",
  موکا: "#8b5e3c",
  نسکافه‌ای: "#a47148",
  "لی آبی": "#6fa8dc",
  "تک رنگ": "linear-gradient(135deg, #f8fafc 0%, #e5e7eb 100%)",
  پلنگی: "linear-gradient(135deg, #d2a15f 0%, #d2a15f 35%, #111827 36%, #111827 48%, #c58b45 49%, #c58b45 72%, #111827 73%, #111827 82%, #e8c07a 83%, #e8c07a 100%)",
  "سفید سورمه ای": "linear-gradient(135deg, #ffffff 0%, #ffffff 50%, #1e3a8a 51%, #1e3a8a 100%)",
  "سفید سرمه ای": "linear-gradient(135deg, #ffffff 0%, #ffffff 50%, #1e3a8a 51%, #1e3a8a 100%)",
  "کرم سورمه ای": "linear-gradient(135deg, #eadcc8 0%, #eadcc8 50%, #1e3a8a 51%, #1e3a8a 100%)",
  "کرم سرمه ای": "linear-gradient(135deg, #eadcc8 0%, #eadcc8 50%, #1e3a8a 51%, #1e3a8a 100%)",
  "کرم قهوه ای": "linear-gradient(135deg, #eadcc8 0%, #eadcc8 50%, #7c4a2d 51%, #7c4a2d 100%)",
  شیری: "#fff7ed",
  نخودی: "#d8c3a5",
  بژ: "#d6b98c",
  کاراملی: "#b7793d",
  قهوه‌ای: "#7c4a2d",
  "قهوه ای": "#7c4a2d",
  شکلاتی: "#5f3825",
  طوسی: "#9ca3af",
  خاکستری: "#9ca3af",
  نقره‌ای: "#c0c0c0",
  "نقره ای": "#c0c0c0",
  دودی: "#4b5563",
  زغالی: "#374151",
  طلایی: "#d4af37",
  رزگلد: "#b76e79",
  زیتونی: "#708238",
  یشمی: "#047857",
  آبی: "#2563eb",
  سرمه‌ای: "#1e3a8a",
  "سرمه ای": "#1e3a8a",
  "سورمه ای": "#1e3a8a",
  سورمه‌ای: "#1e3a8a",
  فیروزه‌ای: "#06b6d4",
  "فیروزه ای": "#06b6d4",
  قرمز: "#dc2626",
  زرشکی: "#8a1538",
  صورتی: "#fb7185",
  گلبهی: "#fb9275",
  بنفش: "#7c3aed",
  یاسی: "#c4b5fd",
  نارنجی: "#f97316",
  زرد: "#facc15"
};

export const normalizeColorName = (value = "") =>
  String(value)
    .trim()
    .replace(/ي/g, "ی")
    .replace(/ك/g, "ک")
    .replace(/\s+/g, " ");

export const getColorCode = (color) => {
  const normalized = normalizeColorName(color);

  if (colorCodes[normalized]) {
    return colorCodes[normalized];
  }

  const foundKey = Object.keys(colorCodes).find((key) => {
    const normalizedKey = normalizeColorName(key);
    return normalized.includes(normalizedKey) || normalizedKey.includes(normalized);
  });

  return foundKey ? colorCodes[foundKey] : "linear-gradient(135deg, #f8fafc 0%, #d1d5db 100%)";
};

export default colorCodes;
